export const generatedScenarioDecisionLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-scenario-decision-ledger",
  "operatingRule": "Every scenario recommendation must expose weighted drivers, uncertainty, economics, assumption blockers, runtime-evidence status, and a decision hash.",
  "scenarioCount": 6,
  "commercializationAllowed": false,
  "topDecision": {
    "scenarioId": "moon-first",
    "name": "Moon-first Bootstrap",
    "rank": 1,
    "summary": "Fastest learning loop and lowest communications burden.",
    "deterministicScores": {
      "benefitScore": 66.95,
      "riskScore": 33.91,
      "uncertaintyPenalty": 8,
      "utility": 67.12
    },
    "decisionReadinessScore": 62.91,
    "decisionLane": "lane-2-conditional-diligence",
    "commercializationAllowed": false,
    "promotionState": "blocked-for-commercial-proof",
    "runtimeEvidence": {
      "requiredContractCount": 3,
      "promotedContractCount": 1,
      "blockedContractCount": 2,
      "coveragePercent": 33.33,
      "evidenceState": "blocked-scenario-runtime-contract-gaps",
      "requiredContractIds": [
        "orekit-propagation-v1",
        "gmat-transfer-v1",
        "openmdao-dymos-optimization-v1"
      ],
      "blockedContractIds": [
        "orekit-propagation-v1",
        "gmat-transfer-v1"
      ],
      "requirements": [
        {
          "contractId": "orekit-propagation-v1",
          "tool": "Orekit",
          "domain": "trajectory-propagation",
          "requiredForScenario": "moon-first",
          "promotionAllowed": false,
          "evidenceState": "blocked-missing-runtime-evidence",
          "promotedArtifactIds": [],
          "promotedValidationHashes": [],
          "promotionRule": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
          "requirementHash": "sha256-7add0df1aa5118a159dc7cc2f35d700bd3690b4bf9f3d347c37aef717e5b4ed2"
        },
        {
          "contractId": "gmat-transfer-v1",
          "tool": "NASA GMAT",
          "domain": "mission-design-transfer",
          "requiredForScenario": "moon-first",
          "promotionAllowed": false,
          "evidenceState": "blocked-missing-runtime-evidence",
          "promotedArtifactIds": [],
          "promotedValidationHashes": [],
          "promotionRule": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
          "requirementHash": "sha256-db8f2f8e7953fa3d3c76201bc17319417cd315a770344e59f00ceeaf8d5c3dca"
        },
        {
          "contractId": "openmdao-dymos-optimization-v1",
          "tool": "OpenMDAO/Dymos",
          "domain": "optimization-and-sensitivity",
          "requiredForScenario": "moon-first",
          "promotionAllowed": true,
          "evidenceState": "runtime-evidence-promoted",
          "promotedArtifactIds": [
            "openmdao-dymos-runtime-moon-logistics-beta-optimization"
          ],
          "promotedValidationHashes": [
            "sha256-c407d3e66feefebc869d40e3bfa3730a4fc2c7615e740449f2da4010e443ddd7"
          ],
          "promotionRule": "Artifact may be reviewed for claim promotion.",
          "requirementHash": "sha256-e719e527e7455325d3bdde0f8daea9477bce4ab55cd14b428790bb3142ac5a15"
        }
      ]
    },
    "topBenefitDrivers": [
      {
        "kind": "benefit",
        "criterion": "optionality",
        "rawScore": 76,
        "weight": 1,
        "weightedValue": 76
      },
      {
        "kind": "benefit",
        "criterion": "resourceConfidence",
        "rawScore": 74,
        "weight": 1,
        "weightedValue": 74
      },
      {
        "kind": "benefit",
        "criterion": "processFit",
        "rawScore": 70,
        "weight": 1,
        "weightedValue": 70
      }
    ],
    "topRiskDrivers": [
      {
        "kind": "risk",
        "criterion": "thermal",
        "rawScore": 48,
        "weight": 0.9,
        "weightedValue": 43.2
      },
      {
        "kind": "risk",
        "criterion": "feedstock",
        "rawScore": 42,
        "weight": 1,
        "weightedValue": 42
      },
      {
        "kind": "risk",
        "criterion": "processMaturity",
        "rawScore": 38,
        "weight": 0.8,
        "weightedValue": 30.4
      }
    ],
    "allDrivers": {
      "benefits": [
        {
          "kind": "benefit",
          "criterion": "optionality",
          "rawScore": 76,
          "weight": 1,
          "weightedValue": 76
        },
        {
          "kind": "benefit",
          "criterion": "resourceConfidence",
          "rawScore": 74,
          "weight": 1,
          "weightedValue": 74
        },
        {
          "kind": "benefit",
          "criterion": "processFit",
          "rawScore": 70,
          "weight": 1,
          "weightedValue": 70
        },
        {
          "kind": "benefit",
          "criterion": "energy",
          "rawScore": 50,
          "weight": 1,
          "weightedValue": 50
        },
        {
          "kind": "benefit",
          "criterion": "vacuum",
          "rawScore": 64,
          "weight": 0.75,
          "weightedValue": 48
        }
      ],
      "risks": [
        {
          "kind": "risk",
          "criterion": "thermal",
          "rawScore": 48,
          "weight": 0.9,
          "weightedValue": 43.2
        },
        {
          "kind": "risk",
          "criterion": "feedstock",
          "rawScore": 42,
          "weight": 1,
          "weightedValue": 42
        },
        {
          "kind": "risk",
          "criterion": "processMaturity",
          "rawScore": 38,
          "weight": 0.8,
          "weightedValue": 30.4
        },
        {
          "kind": "risk",
          "criterion": "transport",
          "rawScore": 25,
          "weight": 1,
          "weightedValue": 25
        },
        {
          "kind": "risk",
          "criterion": "comms",
          "rawScore": 15,
          "weight": 0.8,
          "weightedValue": 12
        }
      ]
    },
    "uncertainty": {
      "iterations": 128,
      "utilityP10": 65.53,
      "utilityMedian": 67.34,
      "utilityP90": 68.89,
      "downsideSpread": 1.81,
      "seed": "moon-first-decision-ledger"
    },
    "economics": {
      "businessReadinessMedian": 76.65,
      "businessReadinessP10": 71.87,
      "businessReadinessP90": 81.23,
      "medianProgramNeedBn": 49.36,
      "medianCapitalGapBn": 0,
      "winProbabilityPercent": 75.78,
      "underfundedProbabilityPercent": 0
    },
    "assumptionImpacts": [
      {
        "assumptionId": "assumption-snapshot-first",
        "title": "Browser consumes reviewed snapshots first",
        "state": "validated-product-rule",
        "uncertainty": "Low",
        "reviewState": "reviewable",
        "promotionAllowed": true,
        "utilityDelta": -0.11,
        "rankDelta": 0,
        "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts."
      },
      {
        "assumptionId": "assumption-no-mercury-first",
        "title": "Mercury cannot be hardcoded as the winning scenario",
        "state": "validated-product-rule",
        "uncertainty": "Low",
        "reviewState": "reviewable",
        "promotionAllowed": true,
        "utilityDelta": 0.2,
        "rankDelta": 0,
        "requiredEvidence": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury."
      },
      {
        "assumptionId": "assumption-social-signals-market-only",
        "title": "Forums and social platforms are market signals, not science evidence",
        "state": "approved-governance-rule",
        "uncertainty": "Low",
        "reviewState": "blocked-for-business-proof",
        "promotionAllowed": false,
        "utilityDelta": -0.08,
        "rankDelta": 0,
        "requiredEvidence": "Social-source records cannot promote claims without a primary-source bridge."
      },
      {
        "assumptionId": "assumption-launch-cost-ranges",
        "title": "Launch economics must use dated ranges and sensitivity bands",
        "state": "hypothesis",
        "uncertainty": "High",
        "reviewState": "blocked-for-business-proof",
        "promotionAllowed": false,
        "utilityDelta": 0.44,
        "rankDelta": 0,
        "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity."
      }
    ],
    "blockedAssumptionCount": 2,
    "runRefs": [
      {
        "id": "run-conservative-moon-first-2026-06-19",
        "runHash": "sha256-f58e6bfe5aae47d6d92365d8b83e1843a5dbf18a3fd82cad81824110d7346601",
        "claimState": "model-derived-unvalidated",
        "selectedUtility": 67.12
      }
    ],
    "blockers": [
      "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
      "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
      "orekit-propagation-v1 runtime evidence missing for moon-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
      "gmat-transfer-v1 runtime evidence missing for moon-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script."
    ],
    "requiredNextEvidence": [
      "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
      "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
      "orekit-propagation-v1 runtime evidence missing for moon-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
      "gmat-transfer-v1 runtime evidence missing for moon-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script."
    ],
    "decisionHash": "sha256-10d9dbf8c908ecc11f38b876ad8b0973845d4b803124a1ce5d524cdd72f1422c"
  },
  "decisionLanes": [
    {
      "scenarioId": "moon-first",
      "rank": 1,
      "decisionLane": "lane-2-conditional-diligence",
      "decisionReadinessScore": 62.91,
      "promotionState": "blocked-for-commercial-proof"
    },
    {
      "scenarioId": "hybrid",
      "rank": 2,
      "decisionLane": "lane-3-watchlist",
      "decisionReadinessScore": 59.78,
      "promotionState": "blocked-for-commercial-proof"
    },
    {
      "scenarioId": "asteroid-first",
      "rank": 3,
      "decisionLane": "lane-4-research-backlog",
      "decisionReadinessScore": 41.63,
      "promotionState": "blocked-for-commercial-proof"
    },
    {
      "scenarioId": "mercury-orbit",
      "rank": 4,
      "decisionLane": "lane-4-research-backlog",
      "decisionReadinessScore": 44.15,
      "promotionState": "blocked-for-commercial-proof"
    },
    {
      "scenarioId": "mars-first",
      "rank": 5,
      "decisionLane": "lane-4-research-backlog",
      "decisionReadinessScore": 41.72,
      "promotionState": "blocked-for-commercial-proof"
    },
    {
      "scenarioId": "mercury-polar",
      "rank": 6,
      "decisionLane": "lane-4-research-backlog",
      "decisionReadinessScore": 41.42,
      "promotionState": "blocked-for-commercial-proof"
    }
  ],
  "evidenceHashes": {
    "scenarios": "sha256-e0d0a78ec49bf1456f7b884a37556bbea289f8740205e65d67dd3db12904089b",
    "defaultWeights": "sha256-5131a19946c87940b7042077430239d4ccf731cd2fe8966b65fa108782d2e6e9",
    "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
    "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
    "modelRunLedger": "sha256-23bb534c7980aa6ab7ba79b91f0d489e8f13deb5ed8999f3170c0c78030563c2",
    "economicsFrontier": "sha256-e2d5dbb01f50cfbb0ccf93703eafd923ae088b68f6f757b3b1e20497ffac4adf",
    "assumptionImpactLedger": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00",
    "sidecarValidationReport": "sha256-aa8df127fd6f74cef0ba42b0ee62827380c4fb8d328808fd77d0793755c90b1f",
    "sidecarPromotionLedger": "sha256-ac772d0c153dc9cb61ecb3605e1fd9c8c15eac4fb7e4977ffa014f84d0368ba6"
  },
  "promotionBlockers": [
    "Commercialization remains blocked until runtime sidecar artifacts cover all required mission-design validation paths.",
    "Dated launch-cost/capex/opex/market source records are required before economics claims can promote.",
    "Resource-dependent scenarios require candidate/body-specific source evidence before material claims can promote."
  ],
  "decisions": [
    {
      "scenarioId": "moon-first",
      "name": "Moon-first Bootstrap",
      "rank": 1,
      "summary": "Fastest learning loop and lowest communications burden.",
      "deterministicScores": {
        "benefitScore": 66.95,
        "riskScore": 33.91,
        "uncertaintyPenalty": 8,
        "utility": 67.12
      },
      "decisionReadinessScore": 62.91,
      "decisionLane": "lane-2-conditional-diligence",
      "commercializationAllowed": false,
      "promotionState": "blocked-for-commercial-proof",
      "runtimeEvidence": {
        "requiredContractCount": 3,
        "promotedContractCount": 1,
        "blockedContractCount": 2,
        "coveragePercent": 33.33,
        "evidenceState": "blocked-scenario-runtime-contract-gaps",
        "requiredContractIds": [
          "orekit-propagation-v1",
          "gmat-transfer-v1",
          "openmdao-dymos-optimization-v1"
        ],
        "blockedContractIds": [
          "orekit-propagation-v1",
          "gmat-transfer-v1"
        ],
        "requirements": [
          {
            "contractId": "orekit-propagation-v1",
            "tool": "Orekit",
            "domain": "trajectory-propagation",
            "requiredForScenario": "moon-first",
            "promotionAllowed": false,
            "evidenceState": "blocked-missing-runtime-evidence",
            "promotedArtifactIds": [],
            "promotedValidationHashes": [],
            "promotionRule": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
            "requirementHash": "sha256-7add0df1aa5118a159dc7cc2f35d700bd3690b4bf9f3d347c37aef717e5b4ed2"
          },
          {
            "contractId": "gmat-transfer-v1",
            "tool": "NASA GMAT",
            "domain": "mission-design-transfer",
            "requiredForScenario": "moon-first",
            "promotionAllowed": false,
            "evidenceState": "blocked-missing-runtime-evidence",
            "promotedArtifactIds": [],
            "promotedValidationHashes": [],
            "promotionRule": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
            "requirementHash": "sha256-db8f2f8e7953fa3d3c76201bc17319417cd315a770344e59f00ceeaf8d5c3dca"
          },
          {
            "contractId": "openmdao-dymos-optimization-v1",
            "tool": "OpenMDAO/Dymos",
            "domain": "optimization-and-sensitivity",
            "requiredForScenario": "moon-first",
            "promotionAllowed": true,
            "evidenceState": "runtime-evidence-promoted",
            "promotedArtifactIds": [
              "openmdao-dymos-runtime-moon-logistics-beta-optimization"
            ],
            "promotedValidationHashes": [
              "sha256-c407d3e66feefebc869d40e3bfa3730a4fc2c7615e740449f2da4010e443ddd7"
            ],
            "promotionRule": "Artifact may be reviewed for claim promotion.",
            "requirementHash": "sha256-e719e527e7455325d3bdde0f8daea9477bce4ab55cd14b428790bb3142ac5a15"
          }
        ]
      },
      "topBenefitDrivers": [
        {
          "kind": "benefit",
          "criterion": "optionality",
          "rawScore": 76,
          "weight": 1,
          "weightedValue": 76
        },
        {
          "kind": "benefit",
          "criterion": "resourceConfidence",
          "rawScore": 74,
          "weight": 1,
          "weightedValue": 74
        },
        {
          "kind": "benefit",
          "criterion": "processFit",
          "rawScore": 70,
          "weight": 1,
          "weightedValue": 70
        }
      ],
      "topRiskDrivers": [
        {
          "kind": "risk",
          "criterion": "thermal",
          "rawScore": 48,
          "weight": 0.9,
          "weightedValue": 43.2
        },
        {
          "kind": "risk",
          "criterion": "feedstock",
          "rawScore": 42,
          "weight": 1,
          "weightedValue": 42
        },
        {
          "kind": "risk",
          "criterion": "processMaturity",
          "rawScore": 38,
          "weight": 0.8,
          "weightedValue": 30.4
        }
      ],
      "allDrivers": {
        "benefits": [
          {
            "kind": "benefit",
            "criterion": "optionality",
            "rawScore": 76,
            "weight": 1,
            "weightedValue": 76
          },
          {
            "kind": "benefit",
            "criterion": "resourceConfidence",
            "rawScore": 74,
            "weight": 1,
            "weightedValue": 74
          },
          {
            "kind": "benefit",
            "criterion": "processFit",
            "rawScore": 70,
            "weight": 1,
            "weightedValue": 70
          },
          {
            "kind": "benefit",
            "criterion": "energy",
            "rawScore": 50,
            "weight": 1,
            "weightedValue": 50
          },
          {
            "kind": "benefit",
            "criterion": "vacuum",
            "rawScore": 64,
            "weight": 0.75,
            "weightedValue": 48
          }
        ],
        "risks": [
          {
            "kind": "risk",
            "criterion": "thermal",
            "rawScore": 48,
            "weight": 0.9,
            "weightedValue": 43.2
          },
          {
            "kind": "risk",
            "criterion": "feedstock",
            "rawScore": 42,
            "weight": 1,
            "weightedValue": 42
          },
          {
            "kind": "risk",
            "criterion": "processMaturity",
            "rawScore": 38,
            "weight": 0.8,
            "weightedValue": 30.4
          },
          {
            "kind": "risk",
            "criterion": "transport",
            "rawScore": 25,
            "weight": 1,
            "weightedValue": 25
          },
          {
            "kind": "risk",
            "criterion": "comms",
            "rawScore": 15,
            "weight": 0.8,
            "weightedValue": 12
          }
        ]
      },
      "uncertainty": {
        "iterations": 128,
        "utilityP10": 65.53,
        "utilityMedian": 67.34,
        "utilityP90": 68.89,
        "downsideSpread": 1.81,
        "seed": "moon-first-decision-ledger"
      },
      "economics": {
        "businessReadinessMedian": 76.65,
        "businessReadinessP10": 71.87,
        "businessReadinessP90": 81.23,
        "medianProgramNeedBn": 49.36,
        "medianCapitalGapBn": 0,
        "winProbabilityPercent": 75.78,
        "underfundedProbabilityPercent": 0
      },
      "assumptionImpacts": [
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "state": "validated-product-rule",
          "uncertainty": "Low",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "utilityDelta": -0.11,
          "rankDelta": 0,
          "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts."
        },
        {
          "assumptionId": "assumption-no-mercury-first",
          "title": "Mercury cannot be hardcoded as the winning scenario",
          "state": "validated-product-rule",
          "uncertainty": "Low",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "utilityDelta": 0.2,
          "rankDelta": 0,
          "requiredEvidence": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury."
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "state": "approved-governance-rule",
          "uncertainty": "Low",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.08,
          "rankDelta": 0,
          "requiredEvidence": "Social-source records cannot promote claims without a primary-source bridge."
        },
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "state": "hypothesis",
          "uncertainty": "High",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": 0.44,
          "rankDelta": 0,
          "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity."
        }
      ],
      "blockedAssumptionCount": 2,
      "runRefs": [
        {
          "id": "run-conservative-moon-first-2026-06-19",
          "runHash": "sha256-f58e6bfe5aae47d6d92365d8b83e1843a5dbf18a3fd82cad81824110d7346601",
          "claimState": "model-derived-unvalidated",
          "selectedUtility": 67.12
        }
      ],
      "blockers": [
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for moon-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for moon-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script."
      ],
      "requiredNextEvidence": [
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for moon-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for moon-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script."
      ],
      "decisionHash": "sha256-10d9dbf8c908ecc11f38b876ad8b0973845d4b803124a1ce5d524cdd72f1422c"
    },
    {
      "scenarioId": "hybrid",
      "name": "Hybrid Moon -> Asteroid -> Mercury",
      "rank": 2,
      "summary": "Bootstrap close, screen feedstock, then scale toward Mercury energy advantage.",
      "deterministicScores": {
        "benefitScore": 80.53,
        "riskScore": 47.09,
        "uncertaintyPenalty": 12,
        "utility": 65.69
      },
      "decisionReadinessScore": 59.78,
      "decisionLane": "lane-3-watchlist",
      "commercializationAllowed": false,
      "promotionState": "blocked-for-commercial-proof",
      "runtimeEvidence": {
        "requiredContractCount": 5,
        "promotedContractCount": 2,
        "blockedContractCount": 3,
        "coveragePercent": 40,
        "evidenceState": "blocked-scenario-runtime-contract-gaps",
        "requiredContractIds": [
          "spice-gf-event-window-v1",
          "orekit-propagation-v1",
          "gmat-transfer-v1",
          "tudat-transfer-v1",
          "openmdao-dymos-optimization-v1"
        ],
        "blockedContractIds": [
          "orekit-propagation-v1",
          "gmat-transfer-v1",
          "tudat-transfer-v1"
        ],
        "requirements": [
          {
            "contractId": "spice-gf-event-window-v1",
            "tool": "NASA NAIF SPICE Geometry Finder",
            "domain": "ephemeris-event-windows",
            "requiredForScenario": "hybrid",
            "promotionAllowed": true,
            "evidenceState": "runtime-evidence-promoted",
            "promotedArtifactIds": [
              "spice-gf-runtime-mercury-clear-link-22deg-2025",
              "spice-gf-runtime-mercury-clear-link-nonzero-window-proof-2025-08"
            ],
            "promotedValidationHashes": [
              "sha256-b821956c87d700973de4b729e8521d88236ca7879136d54efa0e4efa32686d3c",
              "sha256-0e447e7bc3b17a578af3a924a9419b42ea2bf2c23ccd6127e6bf9fd0a5a4528c"
            ],
            "promotionRule": "Artifact may be reviewed for claim promotion.",
            "requirementHash": "sha256-feb8557a9208514bcded44f617bd4626ef9059a1050639519b57d26e639e9dcc"
          },
          {
            "contractId": "orekit-propagation-v1",
            "tool": "Orekit",
            "domain": "trajectory-propagation",
            "requiredForScenario": "hybrid",
            "promotionAllowed": false,
            "evidenceState": "blocked-missing-runtime-evidence",
            "promotedArtifactIds": [],
            "promotedValidationHashes": [],
            "promotionRule": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
            "requirementHash": "sha256-2b8e2794d126e12f1977d2637f81df5f1f3cfd3e745af3e48d43d3ec4711f0a3"
          },
          {
            "contractId": "gmat-transfer-v1",
            "tool": "NASA GMAT",
            "domain": "mission-design-transfer",
            "requiredForScenario": "hybrid",
            "promotionAllowed": false,
            "evidenceState": "blocked-missing-runtime-evidence",
            "promotedArtifactIds": [],
            "promotedValidationHashes": [],
            "promotionRule": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
            "requirementHash": "sha256-52a2c986ce18cf723f04425e3ae22aabbbd2e9bd0ac82ba03f1f5794ac1d37c3"
          },
          {
            "contractId": "tudat-transfer-v1",
            "tool": "Tudat",
            "domain": "cross-tool-trajectory-validation",
            "requiredForScenario": "hybrid",
            "promotionAllowed": false,
            "evidenceState": "blocked-missing-runtime-evidence",
            "promotedArtifactIds": [],
            "promotedValidationHashes": [],
            "promotionRule": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
            "requirementHash": "sha256-37d07018e2579aea5170e47e979ff23394cb6392f2fee28e3c6f43ec695c3bce"
          },
          {
            "contractId": "openmdao-dymos-optimization-v1",
            "tool": "OpenMDAO/Dymos",
            "domain": "optimization-and-sensitivity",
            "requiredForScenario": "hybrid",
            "promotionAllowed": true,
            "evidenceState": "runtime-evidence-promoted",
            "promotedArtifactIds": [
              "openmdao-dymos-runtime-moon-logistics-beta-optimization"
            ],
            "promotedValidationHashes": [
              "sha256-c407d3e66feefebc869d40e3bfa3730a4fc2c7615e740449f2da4010e443ddd7"
            ],
            "promotionRule": "Artifact may be reviewed for claim promotion.",
            "requirementHash": "sha256-c3715076ab910f4097e7d37e6a2991427456b44d261f6b7bf7b8c997f6457fbd"
          }
        ]
      },
      "topBenefitDrivers": [
        {
          "kind": "benefit",
          "criterion": "optionality",
          "rawScore": 92,
          "weight": 1,
          "weightedValue": 92
        },
        {
          "kind": "benefit",
          "criterion": "energy",
          "rawScore": 82,
          "weight": 1,
          "weightedValue": 82
        },
        {
          "kind": "benefit",
          "criterion": "processFit",
          "rawScore": 82,
          "weight": 1,
          "weightedValue": 82
        }
      ],
      "topRiskDrivers": [
        {
          "kind": "risk",
          "criterion": "feedstock",
          "rawScore": 55,
          "weight": 1,
          "weightedValue": 55
        },
        {
          "kind": "risk",
          "criterion": "transport",
          "rawScore": 46,
          "weight": 1,
          "weightedValue": 46
        },
        {
          "kind": "risk",
          "criterion": "thermal",
          "rawScore": 45,
          "weight": 0.9,
          "weightedValue": 40.5
        }
      ],
      "allDrivers": {
        "benefits": [
          {
            "kind": "benefit",
            "criterion": "optionality",
            "rawScore": 92,
            "weight": 1,
            "weightedValue": 92
          },
          {
            "kind": "benefit",
            "criterion": "energy",
            "rawScore": 82,
            "weight": 1,
            "weightedValue": 82
          },
          {
            "kind": "benefit",
            "criterion": "processFit",
            "rawScore": 82,
            "weight": 1,
            "weightedValue": 82
          },
          {
            "kind": "benefit",
            "criterion": "resourceConfidence",
            "rawScore": 68,
            "weight": 1,
            "weightedValue": 68
          },
          {
            "kind": "benefit",
            "criterion": "vacuum",
            "rawScore": 78,
            "weight": 0.75,
            "weightedValue": 58.5
          }
        ],
        "risks": [
          {
            "kind": "risk",
            "criterion": "feedstock",
            "rawScore": 55,
            "weight": 1,
            "weightedValue": 55
          },
          {
            "kind": "risk",
            "criterion": "transport",
            "rawScore": 46,
            "weight": 1,
            "weightedValue": 46
          },
          {
            "kind": "risk",
            "criterion": "thermal",
            "rawScore": 45,
            "weight": 0.9,
            "weightedValue": 40.5
          },
          {
            "kind": "risk",
            "criterion": "processMaturity",
            "rawScore": 46,
            "weight": 0.8,
            "weightedValue": 36.8
          },
          {
            "kind": "risk",
            "criterion": "comms",
            "rawScore": 42,
            "weight": 0.8,
            "weightedValue": 33.6
          }
        ]
      },
      "uncertainty": {
        "iterations": 128,
        "utilityP10": 63.58,
        "utilityMedian": 65.8,
        "utilityP90": 67.74,
        "downsideSpread": 2.22,
        "seed": "hybrid-decision-ledger"
      },
      "economics": {
        "businessReadinessMedian": 72.59,
        "businessReadinessP10": 66.95,
        "businessReadinessP90": 78.5,
        "medianProgramNeedBn": 61.38,
        "medianCapitalGapBn": 0,
        "winProbabilityPercent": 24.22,
        "underfundedProbabilityPercent": 0.39
      },
      "assumptionImpacts": [
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "state": "validated-product-rule",
          "uncertainty": "Low",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "utilityDelta": -0.21,
          "rankDelta": 0,
          "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts."
        },
        {
          "assumptionId": "assumption-no-mercury-first",
          "title": "Mercury cannot be hardcoded as the winning scenario",
          "state": "validated-product-rule",
          "uncertainty": "Low",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "utilityDelta": 0.16,
          "rankDelta": 0,
          "requiredEvidence": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury."
        },
        {
          "assumptionId": "assumption-resource-composition-unknown",
          "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
          "state": "blocked-until-source-backed",
          "uncertainty": "High",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.86,
          "rankDelta": 0,
          "requiredEvidence": "Taxonomy, spectra, or mission data required before promotion."
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "state": "approved-governance-rule",
          "uncertainty": "Low",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.07,
          "rankDelta": 0,
          "requiredEvidence": "Social-source records cannot promote claims without a primary-source bridge."
        },
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "state": "hypothesis",
          "uncertainty": "High",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.07,
          "rankDelta": 0,
          "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity."
        }
      ],
      "blockedAssumptionCount": 3,
      "runRefs": [
        {
          "id": "run-hybrid-base-2026-06-19",
          "runHash": "sha256-584a64cb2fa258c8db87b6e31ef425771de1f617084c2e2fd1774832d7f4d207",
          "claimState": "model-derived-unvalidated",
          "selectedUtility": 65.69
        }
      ],
      "blockers": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for hybrid: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for hybrid: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "tudat-transfer-v1 runtime evidence missing for hybrid: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented."
      ],
      "requiredNextEvidence": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for hybrid: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for hybrid: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script."
      ],
      "decisionHash": "sha256-d1291337540a1d709dbf14299fe94a0c514a6f2fdc474b3eceec237a4bb9b803"
    },
    {
      "scenarioId": "asteroid-first",
      "name": "Asteroid Feedstock-first",
      "rank": 3,
      "summary": "Potential materials bank, but composition and operations are object-specific.",
      "deterministicScores": {
        "benefitScore": 69.21,
        "riskScore": 54.8,
        "uncertaintyPenalty": 18,
        "utility": 51.37
      },
      "decisionReadinessScore": 41.63,
      "decisionLane": "lane-4-research-backlog",
      "commercializationAllowed": false,
      "promotionState": "blocked-for-commercial-proof",
      "runtimeEvidence": {
        "requiredContractCount": 3,
        "promotedContractCount": 0,
        "blockedContractCount": 3,
        "coveragePercent": 0,
        "evidenceState": "blocked-scenario-runtime-contract-gaps",
        "requiredContractIds": [
          "orekit-propagation-v1",
          "gmat-transfer-v1",
          "tudat-transfer-v1"
        ],
        "blockedContractIds": [
          "orekit-propagation-v1",
          "gmat-transfer-v1",
          "tudat-transfer-v1"
        ],
        "requirements": [
          {
            "contractId": "orekit-propagation-v1",
            "tool": "Orekit",
            "domain": "trajectory-propagation",
            "requiredForScenario": "asteroid-first",
            "promotionAllowed": false,
            "evidenceState": "blocked-missing-runtime-evidence",
            "promotedArtifactIds": [],
            "promotedValidationHashes": [],
            "promotionRule": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
            "requirementHash": "sha256-5d3369f85143a15b0477bd7306a89eacd4d768fb1eacc13c626a2f74b3e1dad9"
          },
          {
            "contractId": "gmat-transfer-v1",
            "tool": "NASA GMAT",
            "domain": "mission-design-transfer",
            "requiredForScenario": "asteroid-first",
            "promotionAllowed": false,
            "evidenceState": "blocked-missing-runtime-evidence",
            "promotedArtifactIds": [],
            "promotedValidationHashes": [],
            "promotionRule": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
            "requirementHash": "sha256-b1695f246075f27ed7bce678b9d20df57da822ffad589478a27f6580099a87f5"
          },
          {
            "contractId": "tudat-transfer-v1",
            "tool": "Tudat",
            "domain": "cross-tool-trajectory-validation",
            "requiredForScenario": "asteroid-first",
            "promotionAllowed": false,
            "evidenceState": "blocked-missing-runtime-evidence",
            "promotedArtifactIds": [],
            "promotedValidationHashes": [],
            "promotionRule": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
            "requirementHash": "sha256-572a6f968c6d09b6a472172c0b5c8bb15f27266e1f4b13aaebd672de75829599"
          }
        ]
      },
      "topBenefitDrivers": [
        {
          "kind": "benefit",
          "criterion": "optionality",
          "rawScore": 84,
          "weight": 1,
          "weightedValue": 84
        },
        {
          "kind": "benefit",
          "criterion": "processFit",
          "rawScore": 75,
          "weight": 1,
          "weightedValue": 75
        },
        {
          "kind": "benefit",
          "criterion": "vacuum",
          "rawScore": 85,
          "weight": 0.75,
          "weightedValue": 63.75
        }
      ],
      "topRiskDrivers": [
        {
          "kind": "risk",
          "criterion": "feedstock",
          "rawScore": 72,
          "weight": 1,
          "weightedValue": 72
        },
        {
          "kind": "risk",
          "criterion": "transport",
          "rawScore": 58,
          "weight": 1,
          "weightedValue": 58
        },
        {
          "kind": "risk",
          "criterion": "processMaturity",
          "rawScore": 55,
          "weight": 0.8,
          "weightedValue": 44
        }
      ],
      "allDrivers": {
        "benefits": [
          {
            "kind": "benefit",
            "criterion": "optionality",
            "rawScore": 84,
            "weight": 1,
            "weightedValue": 84
          },
          {
            "kind": "benefit",
            "criterion": "processFit",
            "rawScore": 75,
            "weight": 1,
            "weightedValue": 75
          },
          {
            "kind": "benefit",
            "criterion": "vacuum",
            "rawScore": 85,
            "weight": 0.75,
            "weightedValue": 63.75
          },
          {
            "kind": "benefit",
            "criterion": "energy",
            "rawScore": 61,
            "weight": 1,
            "weightedValue": 61
          },
          {
            "kind": "benefit",
            "criterion": "resourceConfidence",
            "rawScore": 45,
            "weight": 1,
            "weightedValue": 45
          }
        ],
        "risks": [
          {
            "kind": "risk",
            "criterion": "feedstock",
            "rawScore": 72,
            "weight": 1,
            "weightedValue": 72
          },
          {
            "kind": "risk",
            "criterion": "transport",
            "rawScore": 58,
            "weight": 1,
            "weightedValue": 58
          },
          {
            "kind": "risk",
            "criterion": "processMaturity",
            "rawScore": 55,
            "weight": 0.8,
            "weightedValue": 44
          },
          {
            "kind": "risk",
            "criterion": "comms",
            "rawScore": 48,
            "weight": 0.8,
            "weightedValue": 38.4
          },
          {
            "kind": "risk",
            "criterion": "thermal",
            "rawScore": 38,
            "weight": 0.9,
            "weightedValue": 34.2
          }
        ]
      },
      "uncertainty": {
        "iterations": 128,
        "utilityP10": 48.51,
        "utilityMedian": 51.07,
        "utilityP90": 54.39,
        "downsideSpread": 2.55,
        "seed": "asteroid-first-decision-ledger"
      },
      "economics": {
        "businessReadinessMedian": 59.76,
        "businessReadinessP10": 52.92,
        "businessReadinessP90": 67.27,
        "medianProgramNeedBn": 70,
        "medianCapitalGapBn": 0,
        "winProbabilityPercent": 0,
        "underfundedProbabilityPercent": 2.73
      },
      "assumptionImpacts": [
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "state": "validated-product-rule",
          "uncertainty": "Low",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "utilityDelta": -0.46,
          "rankDelta": 0,
          "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts."
        },
        {
          "assumptionId": "assumption-resource-composition-unknown",
          "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
          "state": "blocked-until-source-backed",
          "uncertainty": "High",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -1.68,
          "rankDelta": 0,
          "requiredEvidence": "Taxonomy, spectra, or mission data required before promotion."
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "state": "approved-governance-rule",
          "uncertainty": "Low",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.09,
          "rankDelta": 0,
          "requiredEvidence": "Social-source records cannot promote claims without a primary-source bridge."
        },
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "state": "hypothesis",
          "uncertainty": "High",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.39,
          "rankDelta": 0,
          "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity."
        }
      ],
      "blockedAssumptionCount": 3,
      "runRefs": [
        {
          "id": "run-asteroid-feedstock-probe-2026-06-19",
          "runHash": "sha256-68cd75732797695c5aecb33617bd5132129608750a763e4c998d9e22bf4d1b22",
          "claimState": "model-derived-unvalidated",
          "selectedUtility": 51.37
        }
      ],
      "blockers": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for asteroid-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for asteroid-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "tudat-transfer-v1 runtime evidence missing for asteroid-first: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
        "Candidate-specific SBDB/CAD/taxonomy/spectra evidence required before resource promotion."
      ],
      "requiredNextEvidence": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for asteroid-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for asteroid-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script."
      ],
      "decisionHash": "sha256-d9790d0c91f9265c9681ca6b04883b642500ac3e7a16d26dbf169e61ea5bd051"
    },
    {
      "scenarioId": "mercury-orbit",
      "name": "Mercury Orbit-first",
      "rank": 4,
      "summary": "Maximum long-term energy/vacuum upside, high logistics and autonomy burden.",
      "deterministicScores": {
        "benefitScore": 80.84,
        "riskScore": 75.96,
        "uncertaintyPenalty": 24,
        "utility": 42.95
      },
      "decisionReadinessScore": 44.15,
      "decisionLane": "lane-4-research-backlog",
      "commercializationAllowed": false,
      "promotionState": "blocked-for-commercial-proof",
      "runtimeEvidence": {
        "requiredContractCount": 5,
        "promotedContractCount": 2,
        "blockedContractCount": 3,
        "coveragePercent": 40,
        "evidenceState": "blocked-scenario-runtime-contract-gaps",
        "requiredContractIds": [
          "spice-gf-event-window-v1",
          "orekit-propagation-v1",
          "gmat-transfer-v1",
          "tudat-transfer-v1",
          "openmdao-dymos-optimization-v1"
        ],
        "blockedContractIds": [
          "orekit-propagation-v1",
          "gmat-transfer-v1",
          "tudat-transfer-v1"
        ],
        "requirements": [
          {
            "contractId": "spice-gf-event-window-v1",
            "tool": "NASA NAIF SPICE Geometry Finder",
            "domain": "ephemeris-event-windows",
            "requiredForScenario": "mercury-orbit",
            "promotionAllowed": true,
            "evidenceState": "runtime-evidence-promoted",
            "promotedArtifactIds": [
              "spice-gf-runtime-mercury-clear-link-22deg-2025",
              "spice-gf-runtime-mercury-clear-link-nonzero-window-proof-2025-08"
            ],
            "promotedValidationHashes": [
              "sha256-b821956c87d700973de4b729e8521d88236ca7879136d54efa0e4efa32686d3c",
              "sha256-0e447e7bc3b17a578af3a924a9419b42ea2bf2c23ccd6127e6bf9fd0a5a4528c"
            ],
            "promotionRule": "Artifact may be reviewed for claim promotion.",
            "requirementHash": "sha256-c0f7721260c838c83fc4a42d75bd6d37ea31bb8a2695b40668401b696e953918"
          },
          {
            "contractId": "orekit-propagation-v1",
            "tool": "Orekit",
            "domain": "trajectory-propagation",
            "requiredForScenario": "mercury-orbit",
            "promotionAllowed": false,
            "evidenceState": "blocked-missing-runtime-evidence",
            "promotedArtifactIds": [],
            "promotedValidationHashes": [],
            "promotionRule": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
            "requirementHash": "sha256-6f3d11cd3c2a1a03d16a0655e5273d1b8521d9235314d63ef32e9bb7e491248d"
          },
          {
            "contractId": "gmat-transfer-v1",
            "tool": "NASA GMAT",
            "domain": "mission-design-transfer",
            "requiredForScenario": "mercury-orbit",
            "promotionAllowed": false,
            "evidenceState": "blocked-missing-runtime-evidence",
            "promotedArtifactIds": [],
            "promotedValidationHashes": [],
            "promotionRule": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
            "requirementHash": "sha256-8cc443c4dea65047be17a6f2b487c14b51a345c6aa419e11ca2eaf04f7afc1d3"
          },
          {
            "contractId": "tudat-transfer-v1",
            "tool": "Tudat",
            "domain": "cross-tool-trajectory-validation",
            "requiredForScenario": "mercury-orbit",
            "promotionAllowed": false,
            "evidenceState": "blocked-missing-runtime-evidence",
            "promotedArtifactIds": [],
            "promotedValidationHashes": [],
            "promotionRule": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
            "requirementHash": "sha256-274279fe75894fdc65054e8280646aff67974c7410ffa660481f6059104cbd79"
          },
          {
            "contractId": "openmdao-dymos-optimization-v1",
            "tool": "OpenMDAO/Dymos",
            "domain": "optimization-and-sensitivity",
            "requiredForScenario": "mercury-orbit",
            "promotionAllowed": true,
            "evidenceState": "runtime-evidence-promoted",
            "promotedArtifactIds": [
              "openmdao-dymos-runtime-moon-logistics-beta-optimization"
            ],
            "promotedValidationHashes": [
              "sha256-c407d3e66feefebc869d40e3bfa3730a4fc2c7615e740449f2da4010e443ddd7"
            ],
            "promotionRule": "Artifact may be reviewed for claim promotion.",
            "requirementHash": "sha256-c06ef70db30977f7510ce6097ed7d48e07a68d6fce59b7306bc8f663fd03b8da"
          }
        ]
      },
      "topBenefitDrivers": [
        {
          "kind": "benefit",
          "criterion": "energy",
          "rawScore": 97,
          "weight": 1,
          "weightedValue": 97
        },
        {
          "kind": "benefit",
          "criterion": "optionality",
          "rawScore": 86,
          "weight": 1,
          "weightedValue": 86
        },
        {
          "kind": "benefit",
          "criterion": "processFit",
          "rawScore": 84,
          "weight": 1,
          "weightedValue": 84
        }
      ],
      "topRiskDrivers": [
        {
          "kind": "risk",
          "criterion": "transport",
          "rawScore": 86,
          "weight": 1,
          "weightedValue": 86
        },
        {
          "kind": "risk",
          "criterion": "thermal",
          "rawScore": 82,
          "weight": 0.9,
          "weightedValue": 73.8
        },
        {
          "kind": "risk",
          "criterion": "feedstock",
          "rawScore": 70,
          "weight": 1,
          "weightedValue": 70
        }
      ],
      "allDrivers": {
        "benefits": [
          {
            "kind": "benefit",
            "criterion": "energy",
            "rawScore": 97,
            "weight": 1,
            "weightedValue": 97
          },
          {
            "kind": "benefit",
            "criterion": "optionality",
            "rawScore": 86,
            "weight": 1,
            "weightedValue": 86
          },
          {
            "kind": "benefit",
            "criterion": "processFit",
            "rawScore": 84,
            "weight": 1,
            "weightedValue": 84
          },
          {
            "kind": "benefit",
            "criterion": "vacuum",
            "rawScore": 92,
            "weight": 0.75,
            "weightedValue": 69
          },
          {
            "kind": "benefit",
            "criterion": "resourceConfidence",
            "rawScore": 48,
            "weight": 1,
            "weightedValue": 48
          }
        ],
        "risks": [
          {
            "kind": "risk",
            "criterion": "transport",
            "rawScore": 86,
            "weight": 1,
            "weightedValue": 86
          },
          {
            "kind": "risk",
            "criterion": "thermal",
            "rawScore": 82,
            "weight": 0.9,
            "weightedValue": 73.8
          },
          {
            "kind": "risk",
            "criterion": "feedstock",
            "rawScore": 70,
            "weight": 1,
            "weightedValue": 70
          },
          {
            "kind": "risk",
            "criterion": "comms",
            "rawScore": 78,
            "weight": 0.8,
            "weightedValue": 62.4
          },
          {
            "kind": "risk",
            "criterion": "processMaturity",
            "rawScore": 62,
            "weight": 0.8,
            "weightedValue": 49.6
          }
        ]
      },
      "uncertainty": {
        "iterations": 128,
        "utilityP10": 38.9,
        "utilityMedian": 42.78,
        "utilityP90": 46.63,
        "downsideSpread": 3.87,
        "seed": "mercury-orbit-decision-ledger"
      },
      "economics": {
        "businessReadinessMedian": 55.33,
        "businessReadinessP10": 45.88,
        "businessReadinessP90": 64.63,
        "medianProgramNeedBn": 97.54,
        "medianCapitalGapBn": 0,
        "winProbabilityPercent": 0,
        "underfundedProbabilityPercent": 10.94
      },
      "assumptionImpacts": [
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "state": "validated-product-rule",
          "uncertainty": "Low",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "utilityDelta": -0.04,
          "rankDelta": 0,
          "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts."
        },
        {
          "assumptionId": "assumption-no-mercury-first",
          "title": "Mercury cannot be hardcoded as the winning scenario",
          "state": "validated-product-rule",
          "uncertainty": "Low",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "utilityDelta": -0.28,
          "rankDelta": 0,
          "requiredEvidence": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury."
        },
        {
          "assumptionId": "assumption-resource-composition-unknown",
          "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
          "state": "blocked-until-source-backed",
          "uncertainty": "High",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.82,
          "rankDelta": 0,
          "requiredEvidence": "Taxonomy, spectra, or mission data required before promotion."
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "state": "approved-governance-rule",
          "uncertainty": "Low",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": 0.03,
          "rankDelta": 0,
          "requiredEvidence": "Social-source records cannot promote claims without a primary-source bridge."
        },
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "state": "hypothesis",
          "uncertainty": "High",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.67,
          "rankDelta": 0,
          "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity."
        }
      ],
      "blockedAssumptionCount": 3,
      "runRefs": [],
      "blockers": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for mercury-orbit: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for mercury-orbit: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "tudat-transfer-v1 runtime evidence missing for mercury-orbit: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
        "Mercury thermal/comms/logistics claims require runtime event-window and trajectory artifacts."
      ],
      "requiredNextEvidence": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for mercury-orbit: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for mercury-orbit: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script."
      ],
      "decisionHash": "sha256-3d2d82c36b7e046f9493f8b8f110374461d2bda863c9092e5df482160f350ab4"
    },
    {
      "scenarioId": "mars-first",
      "name": "Mars-first Conventional Expansion",
      "rank": 5,
      "summary": "Strong exploration ecosystem, weak for first industrial-capacity maximization.",
      "deterministicScores": {
        "benefitScore": 48.11,
        "riskScore": 54.84,
        "uncertaintyPenalty": 12,
        "utility": 40.78
      },
      "decisionReadinessScore": 41.72,
      "decisionLane": "lane-4-research-backlog",
      "commercializationAllowed": false,
      "promotionState": "blocked-for-commercial-proof",
      "runtimeEvidence": {
        "requiredContractCount": 3,
        "promotedContractCount": 0,
        "blockedContractCount": 3,
        "coveragePercent": 0,
        "evidenceState": "blocked-scenario-runtime-contract-gaps",
        "requiredContractIds": [
          "orekit-propagation-v1",
          "gmat-transfer-v1",
          "tudat-transfer-v1"
        ],
        "blockedContractIds": [
          "orekit-propagation-v1",
          "gmat-transfer-v1",
          "tudat-transfer-v1"
        ],
        "requirements": [
          {
            "contractId": "orekit-propagation-v1",
            "tool": "Orekit",
            "domain": "trajectory-propagation",
            "requiredForScenario": "mars-first",
            "promotionAllowed": false,
            "evidenceState": "blocked-missing-runtime-evidence",
            "promotedArtifactIds": [],
            "promotedValidationHashes": [],
            "promotionRule": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
            "requirementHash": "sha256-ff2b8397021c7e6ec2a05c01710947935dadfae0d925663329d37abac7d68810"
          },
          {
            "contractId": "gmat-transfer-v1",
            "tool": "NASA GMAT",
            "domain": "mission-design-transfer",
            "requiredForScenario": "mars-first",
            "promotionAllowed": false,
            "evidenceState": "blocked-missing-runtime-evidence",
            "promotedArtifactIds": [],
            "promotedValidationHashes": [],
            "promotionRule": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
            "requirementHash": "sha256-eacea1c15712c0b6a921d3f1ecc740bbe03336155bdbcde29c41d136db5dfdff"
          },
          {
            "contractId": "tudat-transfer-v1",
            "tool": "Tudat",
            "domain": "cross-tool-trajectory-validation",
            "requiredForScenario": "mars-first",
            "promotionAllowed": false,
            "evidenceState": "blocked-missing-runtime-evidence",
            "promotedArtifactIds": [],
            "promotedValidationHashes": [],
            "promotionRule": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
            "requirementHash": "sha256-1c5bab76e7fcb372360be3ce95cc7d4b49394e06099e8cc38db236ad3d3e48e9"
          }
        ]
      },
      "topBenefitDrivers": [
        {
          "kind": "benefit",
          "criterion": "optionality",
          "rawScore": 65,
          "weight": 1,
          "weightedValue": 65
        },
        {
          "kind": "benefit",
          "criterion": "resourceConfidence",
          "rawScore": 65,
          "weight": 1,
          "weightedValue": 65
        },
        {
          "kind": "benefit",
          "criterion": "processFit",
          "rawScore": 46,
          "weight": 1,
          "weightedValue": 46
        }
      ],
      "topRiskDrivers": [
        {
          "kind": "risk",
          "criterion": "transport",
          "rawScore": 62,
          "weight": 1,
          "weightedValue": 62
        },
        {
          "kind": "risk",
          "criterion": "comms",
          "rawScore": 64,
          "weight": 0.8,
          "weightedValue": 51.2
        },
        {
          "kind": "risk",
          "criterion": "thermal",
          "rawScore": 56,
          "weight": 0.9,
          "weightedValue": 50.4
        }
      ],
      "allDrivers": {
        "benefits": [
          {
            "kind": "benefit",
            "criterion": "optionality",
            "rawScore": 65,
            "weight": 1,
            "weightedValue": 65
          },
          {
            "kind": "benefit",
            "criterion": "resourceConfidence",
            "rawScore": 65,
            "weight": 1,
            "weightedValue": 65
          },
          {
            "kind": "benefit",
            "criterion": "processFit",
            "rawScore": 46,
            "weight": 1,
            "weightedValue": 46
          },
          {
            "kind": "benefit",
            "criterion": "energy",
            "rawScore": 36,
            "weight": 1,
            "weightedValue": 36
          },
          {
            "kind": "benefit",
            "criterion": "vacuum",
            "rawScore": 22,
            "weight": 0.75,
            "weightedValue": 16.5
          }
        ],
        "risks": [
          {
            "kind": "risk",
            "criterion": "transport",
            "rawScore": 62,
            "weight": 1,
            "weightedValue": 62
          },
          {
            "kind": "risk",
            "criterion": "comms",
            "rawScore": 64,
            "weight": 0.8,
            "weightedValue": 51.2
          },
          {
            "kind": "risk",
            "criterion": "thermal",
            "rawScore": 56,
            "weight": 0.9,
            "weightedValue": 50.4
          },
          {
            "kind": "risk",
            "criterion": "feedstock",
            "rawScore": 48,
            "weight": 1,
            "weightedValue": 48
          },
          {
            "kind": "risk",
            "criterion": "processMaturity",
            "rawScore": 44,
            "weight": 0.8,
            "weightedValue": 35.2
          }
        ]
      },
      "uncertainty": {
        "iterations": 128,
        "utilityP10": 38.16,
        "utilityMedian": 40.96,
        "utilityP90": 43.65,
        "downsideSpread": 2.8,
        "seed": "mars-first-decision-ledger"
      },
      "economics": {
        "businessReadinessMedian": 63.22,
        "businessReadinessP10": 57.41,
        "businessReadinessP90": 68.72,
        "medianProgramNeedBn": 68.05,
        "medianCapitalGapBn": 0,
        "winProbabilityPercent": 0,
        "underfundedProbabilityPercent": 1.95
      },
      "assumptionImpacts": [
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "state": "validated-product-rule",
          "uncertainty": "Low",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "utilityDelta": 0.33,
          "rankDelta": 0,
          "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts."
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "state": "approved-governance-rule",
          "uncertainty": "Low",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.06,
          "rankDelta": 0,
          "requiredEvidence": "Social-source records cannot promote claims without a primary-source bridge."
        },
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "state": "hypothesis",
          "uncertainty": "High",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.05,
          "rankDelta": 0,
          "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity."
        }
      ],
      "blockedAssumptionCount": 2,
      "runRefs": [],
      "blockers": [
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for mars-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for mars-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "tudat-transfer-v1 runtime evidence missing for mars-first: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented."
      ],
      "requiredNextEvidence": [
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for mars-first: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for mars-first: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "tudat-transfer-v1 runtime evidence missing for mars-first: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented."
      ],
      "decisionHash": "sha256-81bc9923440bb378abb0e1f0e16683f5e7d4df6014535645506f115bb13313bb"
    },
    {
      "scenarioId": "mercury-polar",
      "name": "Mercury Polar Surface-first",
      "rank": 6,
      "summary": "Polar volatile access is attractive, but surface thermal/comms risk is severe.",
      "deterministicScores": {
        "benefitScore": 76.32,
        "riskScore": 78.13,
        "uncertaintyPenalty": 26,
        "utility": 37.95
      },
      "decisionReadinessScore": 41.42,
      "decisionLane": "lane-4-research-backlog",
      "commercializationAllowed": false,
      "promotionState": "blocked-for-commercial-proof",
      "runtimeEvidence": {
        "requiredContractCount": 5,
        "promotedContractCount": 2,
        "blockedContractCount": 3,
        "coveragePercent": 40,
        "evidenceState": "blocked-scenario-runtime-contract-gaps",
        "requiredContractIds": [
          "spice-gf-event-window-v1",
          "orekit-propagation-v1",
          "gmat-transfer-v1",
          "tudat-transfer-v1",
          "openmdao-dymos-optimization-v1"
        ],
        "blockedContractIds": [
          "orekit-propagation-v1",
          "gmat-transfer-v1",
          "tudat-transfer-v1"
        ],
        "requirements": [
          {
            "contractId": "spice-gf-event-window-v1",
            "tool": "NASA NAIF SPICE Geometry Finder",
            "domain": "ephemeris-event-windows",
            "requiredForScenario": "mercury-polar",
            "promotionAllowed": true,
            "evidenceState": "runtime-evidence-promoted",
            "promotedArtifactIds": [
              "spice-gf-runtime-mercury-clear-link-22deg-2025",
              "spice-gf-runtime-mercury-clear-link-nonzero-window-proof-2025-08"
            ],
            "promotedValidationHashes": [
              "sha256-b821956c87d700973de4b729e8521d88236ca7879136d54efa0e4efa32686d3c",
              "sha256-0e447e7bc3b17a578af3a924a9419b42ea2bf2c23ccd6127e6bf9fd0a5a4528c"
            ],
            "promotionRule": "Artifact may be reviewed for claim promotion.",
            "requirementHash": "sha256-fab7e6ec32eda0cce87a8f84e15376d06a28d2966dc75d3257ee059dbeb82090"
          },
          {
            "contractId": "orekit-propagation-v1",
            "tool": "Orekit",
            "domain": "trajectory-propagation",
            "requiredForScenario": "mercury-polar",
            "promotionAllowed": false,
            "evidenceState": "blocked-missing-runtime-evidence",
            "promotedArtifactIds": [],
            "promotedValidationHashes": [],
            "promotionRule": "Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
            "requirementHash": "sha256-39f7c17f1a0656dff9b3e4b21d1c9c591db95ad3a755d769e0369843186abfdb"
          },
          {
            "contractId": "gmat-transfer-v1",
            "tool": "NASA GMAT",
            "domain": "mission-design-transfer",
            "requiredForScenario": "mercury-polar",
            "promotionAllowed": false,
            "evidenceState": "blocked-missing-runtime-evidence",
            "promotedArtifactIds": [],
            "promotedValidationHashes": [],
            "promotionRule": "GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
            "requirementHash": "sha256-852c445bab03a7f3ddae3be68519b103bdcdbebfafa0ca963195853a625519cb"
          },
          {
            "contractId": "tudat-transfer-v1",
            "tool": "Tudat",
            "domain": "cross-tool-trajectory-validation",
            "requiredForScenario": "mercury-polar",
            "promotionAllowed": false,
            "evidenceState": "blocked-missing-runtime-evidence",
            "promotedArtifactIds": [],
            "promotedValidationHashes": [],
            "promotionRule": "Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
            "requirementHash": "sha256-18cf8ebfae6492f9bd40e08731c9e782b5b79376a92e4db0cfb3a1c0bcb255a0"
          },
          {
            "contractId": "openmdao-dymos-optimization-v1",
            "tool": "OpenMDAO/Dymos",
            "domain": "optimization-and-sensitivity",
            "requiredForScenario": "mercury-polar",
            "promotionAllowed": true,
            "evidenceState": "runtime-evidence-promoted",
            "promotedArtifactIds": [
              "openmdao-dymos-runtime-moon-logistics-beta-optimization"
            ],
            "promotedValidationHashes": [
              "sha256-c407d3e66feefebc869d40e3bfa3730a4fc2c7615e740449f2da4010e443ddd7"
            ],
            "promotionRule": "Artifact may be reviewed for claim promotion.",
            "requirementHash": "sha256-046f212e422354da56d73a86f45246f5e563864501ffed6799f2136c960de9eb"
          }
        ]
      },
      "topBenefitDrivers": [
        {
          "kind": "benefit",
          "criterion": "energy",
          "rawScore": 88,
          "weight": 1,
          "weightedValue": 88
        },
        {
          "kind": "benefit",
          "criterion": "optionality",
          "rawScore": 80,
          "weight": 1,
          "weightedValue": 80
        },
        {
          "kind": "benefit",
          "criterion": "processFit",
          "rawScore": 74,
          "weight": 1,
          "weightedValue": 74
        }
      ],
      "topRiskDrivers": [
        {
          "kind": "risk",
          "criterion": "transport",
          "rawScore": 90,
          "weight": 1,
          "weightedValue": 90
        },
        {
          "kind": "risk",
          "criterion": "thermal",
          "rawScore": 88,
          "weight": 0.9,
          "weightedValue": 79.2
        },
        {
          "kind": "risk",
          "criterion": "comms",
          "rawScore": 82,
          "weight": 0.8,
          "weightedValue": 65.6
        }
      ],
      "allDrivers": {
        "benefits": [
          {
            "kind": "benefit",
            "criterion": "energy",
            "rawScore": 88,
            "weight": 1,
            "weightedValue": 88
          },
          {
            "kind": "benefit",
            "criterion": "optionality",
            "rawScore": 80,
            "weight": 1,
            "weightedValue": 80
          },
          {
            "kind": "benefit",
            "criterion": "processFit",
            "rawScore": 74,
            "weight": 1,
            "weightedValue": 74
          },
          {
            "kind": "benefit",
            "criterion": "vacuum",
            "rawScore": 86,
            "weight": 0.75,
            "weightedValue": 64.5
          },
          {
            "kind": "benefit",
            "criterion": "resourceConfidence",
            "rawScore": 56,
            "weight": 1,
            "weightedValue": 56
          }
        ],
        "risks": [
          {
            "kind": "risk",
            "criterion": "transport",
            "rawScore": 90,
            "weight": 1,
            "weightedValue": 90
          },
          {
            "kind": "risk",
            "criterion": "thermal",
            "rawScore": 88,
            "weight": 0.9,
            "weightedValue": 79.2
          },
          {
            "kind": "risk",
            "criterion": "comms",
            "rawScore": 82,
            "weight": 0.8,
            "weightedValue": 65.6
          },
          {
            "kind": "risk",
            "criterion": "feedstock",
            "rawScore": 64,
            "weight": 1,
            "weightedValue": 64
          },
          {
            "kind": "risk",
            "criterion": "processMaturity",
            "rawScore": 66,
            "weight": 0.8,
            "weightedValue": 52.8
          }
        ]
      },
      "uncertainty": {
        "iterations": 128,
        "utilityP10": 33.71,
        "utilityMedian": 37.84,
        "utilityP90": 41.82,
        "downsideSpread": 4.13,
        "seed": "mercury-polar-decision-ledger"
      },
      "economics": {
        "businessReadinessMedian": 53.68,
        "businessReadinessP10": 44.62,
        "businessReadinessP90": 63.86,
        "medianProgramNeedBn": 104.1,
        "medianCapitalGapBn": 0,
        "winProbabilityPercent": 0,
        "underfundedProbabilityPercent": 11.91
      },
      "assumptionImpacts": [
        {
          "assumptionId": "assumption-snapshot-first",
          "title": "Browser consumes reviewed snapshots first",
          "state": "validated-product-rule",
          "uncertainty": "Low",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "utilityDelta": 0.17,
          "rankDelta": 0,
          "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts."
        },
        {
          "assumptionId": "assumption-no-mercury-first",
          "title": "Mercury cannot be hardcoded as the winning scenario",
          "state": "validated-product-rule",
          "uncertainty": "Low",
          "reviewState": "reviewable",
          "promotionAllowed": true,
          "utilityDelta": -0.45,
          "rankDelta": 0,
          "requiredEvidence": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury."
        },
        {
          "assumptionId": "assumption-resource-composition-unknown",
          "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
          "state": "blocked-until-source-backed",
          "uncertainty": "High",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.04,
          "rankDelta": 0,
          "requiredEvidence": "Taxonomy, spectra, or mission data required before promotion."
        },
        {
          "assumptionId": "assumption-social-signals-market-only",
          "title": "Forums and social platforms are market signals, not science evidence",
          "state": "approved-governance-rule",
          "uncertainty": "Low",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": 0.03,
          "rankDelta": 0,
          "requiredEvidence": "Social-source records cannot promote claims without a primary-source bridge."
        },
        {
          "assumptionId": "assumption-launch-cost-ranges",
          "title": "Launch economics must use dated ranges and sensitivity bands",
          "state": "hypothesis",
          "uncertainty": "High",
          "reviewState": "blocked-for-business-proof",
          "promotionAllowed": false,
          "utilityDelta": -0.63,
          "rankDelta": 0,
          "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity."
        }
      ],
      "blockedAssumptionCount": 3,
      "runRefs": [],
      "blockers": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for mercury-polar: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for mercury-polar: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script.",
        "tudat-transfer-v1 runtime evidence missing for mercury-polar: Tudat artifacts are comparison evidence only until disagreement bounds versus Orekit/GMAT are documented.",
        "Mercury thermal/comms/logistics claims require runtime event-window and trajectory artifacts."
      ],
      "requiredNextEvidence": [
        "Asteroid/Mercury resource composition remains unknown until directly sourced: Taxonomy, spectra, or mission data required before promotion.",
        "Forums and social platforms are market signals, not science evidence: Social-source records cannot promote claims without a primary-source bridge.",
        "Launch economics must use dated ranges and sensitivity bands: Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "orekit-propagation-v1 runtime evidence missing for mercury-polar: Orekit artifacts can promote only after a runtime propagation has a passing independent comparison or residual bound.",
        "gmat-transfer-v1 runtime evidence missing for mercury-polar: GMAT artifacts can promote only after transfer constraints and residuals are reproducible from a hashed script."
      ],
      "decisionHash": "sha256-8bcef4c6d0b17543fd330abfe053478152e09a623045d677ca24c9f669159934"
    }
  ],
  "ledgerHash": "sha256-81950fc02de53a9e04b10cee8abbae2b8240602d3a32a2078822109dea557b13"
}
;
